export function openWikiLink() {
  const chooChooDrawUrl = `https://wiki.trains.cards/`;
  window.open(chooChooDrawUrl, "_blank")?.focus();
}
